import { Outlet } from "react-router-dom";
import { Header } from "../UI/Header/Header";
import { Footer } from "../UI/Footer/Footer";

export const Layout = () => {
  return (
    <>
      <Header />
      <main className="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};
